module.exports = {"140110001":"义井街道","140110002":"罗城街道","140110003":"晋源街道","140110100":"金胜镇","140110101":"晋祠镇","140110102":"姚村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140110.json
// module id = 351
// module chunks = 0